'use client';

import { type SVGProps } from 'react';

export function Skiff(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            viewBox="0 0 559 137"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            height={24}
            role="img"
            {...props}>
            <title>Skiff</title>
            <path
                d="M49.6965 56.2744H24.8482V32.2492H44.8516C47.5223 32.2492 49.6965 30.0394 49.6965 27.3248V6.9929H73.3335V32.2492C73.3335 45.5206 62.7534 56.2744 49.6965 56.2744ZM24.8482 58.7366H0V82.7618H20.0033C22.6741 82.7618 24.8482 84.9717 24.8482 87.6863V108.018H48.4852V82.7618C48.4852 69.4904 37.9052 58.7366 24.8482 58.7366ZM104.238 57.5055C101.567 57.5055 99.3929 55.2957 99.3929 52.5811V32.2492H75.7559V57.5055C75.7559 70.7769 86.3359 81.5307 99.3929 81.5307H124.241V57.5055H104.238ZM50.9077 108.018V133.274H74.5447V112.943C74.5447 110.228 76.7188 108.018 79.3896 108.018H99.3929V83.993H74.5447C61.4877 83.993 50.9077 94.7467 50.9077 108.018Z"
                fill="currentColor"
            />
            <path
                d="M176.439 90.8866C177.006 109.96 187.959 120.914 212.698 120.914C238.004 120.914 244.047 112.227 244.047 99.3849C244.047 87.6762 237.06 81.2553 222.896 79.1779L193.813 75.0232C172.473 72.0016 161.331 60.8595 161.331 41.2191C161.331 20.2567 176.817 4.01563 210.432 4.01563C245.747 4.01563 260.666 21.7675 262.366 44.2407H243.481C241.592 29.1327 231.583 19.1236 210.243 19.1236C189.847 19.1236 180.971 27.9996 180.971 40.6525C180.971 49.9062 186.07 56.7048 197.779 58.4044L228.562 62.9368C250.468 66.1473 263.688 76.1563 263.688 96.9298C263.688 121.669 248.58 136.022 212.698 136.022C171.529 136.022 157.554 114.493 157.554 90.8866H176.439Z"
                fill="currentColor"
            />
            <path
                d="M354.26 133L321.023 89.7535L303.271 106.561V133H284.386V0.805176H303.271V85.5988C306.481 81.633 309.881 77.856 312.902 75.0232L351.239 38.5752H374.279V39.1417L333.109 78.2337L377.867 133H354.26Z"
                fill="currentColor"
            />
            <path
                d="M417.562 58.7821V133H398.677V59.3487C398.677 56.5159 397.733 55.5717 394.9 55.5717H382.436V38.5752H396.789C409.064 38.5752 417.373 46.6957 417.562 58.7821ZM391.501 24.4114V7.41493H415.296V24.4114H391.501Z"
                fill="currentColor"
            />
            <path
                d="M448.678 133V53.1166H432.626V43.2964L448.678 37.8198V24.0337C448.678 8.92573 456.232 0.805176 479.083 0.805176H495.891V14.9689H466.052V38.5752H507.788V24.0337C507.788 8.92573 515.342 0.805176 538.193 0.805176H558.778V14.9689H525.162V38.5752H553.112V53.1166H526.673V133H507.788V53.1166H467.563V133H448.678Z"
                fill="currentColor"
            />
        </svg>
    );
}
